export const createGenericIntervention = async (existingData, newData, addRecord, updateRecord, writes) => {
  let intervention = undefined;
  if (existingData === undefined) {
    intervention = new Weaver.Node();
    Weaver.Functions.popWrites(intervention, writes);
    const rel = intervention.relation('http://www.w3.org/1999/02/22-rdf-syntax-ns#type');
    rel.add(Weaver.Node.get('http://pms.coentunnelcompany.nl/rdl#Intervention'));
    Weaver.Functions.popWrites(rel, writes);
    newData.intervention = intervention;
  } else {
    intervention = existingData.intervention;
    await intervention.load();
  }

  // Section fields on intervention
  if (newData.name !== existingData?.name) {
    intervention.set('http://pms.coentunnelcompany.nl/rdl#hasName', newData.name);
    Weaver.Functions.popWrites(intervention.attribute('http://pms.coentunnelcompany.nl/rdl#hasName'), writes);
  }
  if (newData.reason !== existingData?.reason) {
    intervention.set('http://pms.coentunnelcompany.nl/rdl#isJustifiedBy', newData.reason);
    Weaver.Functions.popWrites(intervention.attribute('http://pms.coentunnelcompany.nl/rdl#isJustifiedBy'), writes);
  }
  if (newData.docid !== existingData?.docid) {
    intervention.set('http://pms.coentunnelcompany.nl/rdl#isRepresentedIn', newData.docid);
    Weaver.Functions.popWrites(intervention.attribute('http://pms.coentunnelcompany.nl/rdl#isRepresentedIn'), writes);
  }
  
  // Check links to quarter nodes
  const wishList = _.clone(newData.qname);
  intervention.relation('http://pms.coentunnelcompany.nl/rdl#quarter').allRecords().forEach((rec) => {
    const i = wishList.indexOf(rec.toNode.id());
    if (i != -1) {
      wishList.splice(i, 1);
    } else {
      Weaver.Functions.batchRemove([rec.relNode], writes);
    }
  })
  wishList.forEach((id) => {
    intervention.relation('http://pms.coentunnelcompany.nl/rdl#quarter').add(Weaver.Node.get(id))
    Weaver.Functions.popWrites(intervention.relation('http://pms.coentunnelcompany.nl/rdl#quarter'), writes);
  });

  if (newData.records === undefined) {
    newData.records = [];
  }

  // Check if a record was removed
  if (existingData !== undefined && existingData.records !== undefined) {
    const removeList = [];
    existingData.records.forEach((record) => {
      let found = false;
      newData.records.forEach((match) => {
        if(record.record.equals(match.record)) {
          found = true;
        }
      });
      if (!found) {
        removeList.push(record.record);
      }
    });
    Weaver.Functions.batchRemove(removeList, writes);
  }

  // Iterate over new records
  await Promise.map(newData.records, async (record) => {
    if (existingData !== undefined && existingData.records !== undefined) {
      let oldRecord = undefined;
      for (var i = 0; i < existingData.records.length; i++) {
        let candidate = existingData.records[i];
        if (candidate.record.equals(record.record)) {
          oldRecord = candidate;
          break;
        }
      }
      if (oldRecord === undefined) {
        await addRecord(intervention, record, writes);
      } else {
        await updateRecord(oldRecord, record, writes);
      }
    } else {
      await addRecord(intervention, record, writes);
    }
  });
  return { writes, newData };
}

export const performIntervention = async (interventionNode) => {
  const ids = interventionNode.relation('http://pms.coentunnelcompany.nl/rdl#appliesTo').all();
  const records = await new Weaver.Query().restrict(ids).selectOut('http://pms.coentunnelcompany.nl/rdl#appliesTo').find();

  // Process each record separately
  await Promise.map(records, async (record) => {
    const newSubject = record.relation('http://pms.coentunnelcompany.nl/rdl#newSubject').first();
    const newPredicate = record.relation('http://pms.coentunnelcompany.nl/rdl#newPredicate').first();
    const oldSubject = record.relation('http://pms.coentunnelcompany.nl/rdl#oldSubject').first();
    const oldPredicate = record.relation('http://pms.coentunnelcompany.nl/rdl#oldPredicate').first();
    let mode = undefined;
    if (oldSubject === undefined && newSubject !== undefined) {
      mode = 'create';
    } else if (oldSubject !== undefined && newSubject !== undefined) {
      mode = 'update';
    } else if (oldSubject !== undefined && newSubject === undefined) {
      mode = 'remove';
    } else {
      throw new Error(`Can not process record ${record.id()}`)
    }

    // Apply
    if (mode === 'remove') {
      const oldSubjectLoaded = await new Weaver.Query().restrict(oldSubject).first();
      const predicate = oldPredicate.id()
      // Attribute
      const matchValue = record.attribute('http://pms.coentunnelcompany.nl/rdl#oldObject').first()
      if(matchValue !== undefined) {
        const attRecords = oldSubjectLoaded.attribute(predicate).allRecords();
        const matchRecords = [];
        attRecords.forEach((attRecord) => {
          if (attRecord.value == matchValue) {
            matchRecords.push(attRecord)
          }
        })
        if (matchRecords.length != 1) {
          throw new Error(`Trying to delete one attribute with value ${matchValue}, but found ${matchRecords.length} (not 1)`);
        }
        await matchRecords[0].attNode.destroy();

      // Relation
      } else {
        const oldObject = record.relation('http://pms.coentunnelcompany.nl/rdl#oldObject').first()
        const matchRecords = oldSubjectLoaded.relation(predicate)._getRecordsForToNode(oldObject);
        if (matchRecords.length != 1) {
          throw new Error(`Trying to delete one relation to ${oldObject.id()}, but found ${matchRecords.length} (not 1)`);
        }
        await matchRecords[0].relNode.destroy();
      }

    } else if(mode === 'create' || mode === 'update') {
      const newSubjectLoaded = await new Weaver.Query().restrict(newSubject).first();
      const predicate = newPredicate.id()
      // Attribute
      const newAttributeRecord = record.attribute('http://pms.coentunnelcompany.nl/rdl#newObject').allRecords()[0];
      if (newAttributeRecord != undefined) {
        newSubjectLoaded.set(predicate, newAttributeRecord.value, { dataType: newAttributeRecord.dataType }); // sdk will make this an update if a value existed

      // Relation
      } else {
        const newObject = record.relation('http://pms.coentunnelcompany.nl/rdl#newObject').first();
        const matchRecords = newSubject.relation(predicate)._getRecordsForToNode(newObject);
        if (matchRecords.length === 0) {
          newSubjectLoaded.relation(predicate).add(newObject);
        } else if (matchRecords.length === 1) {
          newSubjectLoaded.relation(predicate).update(matchRecords[0], newObject);
        } else {
          throw new Error(`Trying to update one relation to ${newObject.id()}, but found ${matchRecords.length} (> 1)`);
        }
      }
      await newSubjectLoaded.save();
    }
  });
}
